module.exports = __webpack_public_path__ + "static/media/has.516a755e.svg";